import { IncomingMessage } from "http";
import { NextApiResponse } from "next";
import { ServerResponse } from "http";
import { destroyCookie } from "nookies";
import { parseCookies } from "nookies";
import { setCookie } from "nookies";

export const storeCookie = (
  res: NextApiResponse | ServerResponse,
  name: string,
  value: string,
  maxAge?: number,
  httpOnly?: boolean
) => {
  setCookie({ res }, name, value, {
    // if httpOnly is not defined set it true to be safe
    httpOnly: httpOnly === undefined ? true : httpOnly,
    path: "/",
    sameSite: "lax",
    secure: process.env.NODE_ENV === "production",
    maxAge,
  });
};

export const readCookie = (req: IncomingMessage, name: string) => {
  return parseCookies({
    req,
  })[name];
};

export const removeCookie = (
  res: NextApiResponse | ServerResponse,
  name: string
) => {
  destroyCookie({ res }, name, {
    path: "/",
  });
};
